var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.632585 0.193451L0.210088 0.589975C0.0781427 0.714768 0.00545274 0.880798 0.00545272 1.05825C0.0054527 1.23559 0.0781426 1.40182 0.210088 1.52662L4.99658 6.04989L0.204776 10.5784C0.0728302 10.703 0.000244303 10.8692 0.000244279 11.0465C0.000244256 11.2239 0.0728301 11.3902 0.204776 11.5149L0.624669 11.9115C0.897725 12.1698 1.34251 12.1698 1.61556 11.9115L7.3413 6.51983C7.47314 6.39524 7.56603 6.2292 7.56603 6.05028L7.56603 6.04821C7.56603 5.87077 7.47304 5.70474 7.3413 5.58014L1.63108 0.193451C1.49924 0.0686571 1.31824 0.000158483 1.13058 -3.79987e-05C0.942819 -3.80234e-05 0.764323 0.068657 0.632585 0.193451Z",
    fill: "#003471"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.62f9a0234545901eebf234e9d1f04727.svg";
export { ForwardRef as ReactComponent };